import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProductsService } from 'src/app/api';
import { BaremeResponse } from 'src/app/api/model/baremeResponse';
import { CombinedStore } from 'src/app/core/combined.store';

export const revenusResolver: ResolveFn<BaremeResponse | null> = () => {
  const productService = inject(ProductsService);
  const store = inject(CombinedStore);

  return productService.apiProductReferenceGet(store.path()).pipe(
    catchError((err: Error) => {
      console.error('Failed to load product reference', err);
      return of(null);
    }),
  );
};
